import { faCheck as fasCheck } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { type ReactNode } from "react";

export interface ListUi3ContextType {
	listItemStyle: ReactNode;
}

export const ListUi3ContextDefaultValue = {
	listItemStyle: <FontAwesomeIcon icon={fasCheck} />,
};

export const ListUi3Context = React.createContext<ListUi3ContextType>(ListUi3ContextDefaultValue);
